import React from "react"

import {MenuOption} from "@lexical/react/LexicalTypeaheadMenuPlugin"

export class EmojiOption extends MenuOption {
    label   : string
    emoji   : string
    keywords: Array<string>

    constructor(
        label   : string,
        emoji   : string,
        options : {
            keywords?: Array<string>
        },
    ) {
        super(label)
        this.label      = label
        this.emoji      = emoji
        this.keywords   = options.keywords || []
    }

    get iconComponent() {
        return <div className="m-r-5">{this.emoji}</div>
    }
}